import { useEffect, useState } from 'react';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { useIsMapViewEnabled } from 'hooks/use-is-map-view-enabled.hook';

interface UseTopPositionReturnValues {
  isTopPosition: boolean;
}

export const useTopPosition = (): UseTopPositionReturnValues => {
  const isMapViewEnabled = useIsMapViewEnabled();
  const isMobileDevice = useIsSmallViewportWidth();
  const [isTopPosition, setIsTopPosition] = useState(null);

  useEffect(() => {
    const updateTopPosition = () => {
      const screenHeight = window.innerHeight;
      const contentElement = document.querySelector('.container-content');

      if (contentElement && isMapViewEnabled && isMobileDevice) {
        const top = contentElement.getBoundingClientRect().top + window.scrollY;

        setIsTopPosition(top >= screenHeight / 2);
      }
    };

    window.addEventListener('touchend', updateTopPosition);

    updateTopPosition();

    return () => {
      window.removeEventListener('touchend', updateTopPosition);
    };
  }, [isMapViewEnabled, isMobileDevice]);

  return { isTopPosition };
};
